<template>
  <div class="container">
    <Loading v-show="pageLoading" />
    <div class="width_wrap">
      <MyPageSidebar />
      <div class="body_content sub">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">[기관] 진단신청<span></span></h1>
        <div class="glores-B-list-h2">
          <div class="h-left">
            <!-- 필요시 여기에 검색 또는 필터 UI 추가 -->
          </div>
        </div>

        <div
          v-if="listLoading"
          class="loading-indicator"
          style="text-align: center; padding: 20px"
        >
          진단신청 목록을 불러오는 중...
        </div>
        <div
          v-if="error"
          class="error-message"
          style="text-align: center; padding: 20px; color: red"
        >
          {{ error }}
        </div>

        <div v-if="!listLoading && !error" class="glores-B-list-type1">
          <n-data-table
            v-if="orders.length > 0"
            :columns="columns"
            :data="orders"
            :pagination="pagination"
            :bordered="false"
            :single-line="false"
          />
          <ul v-else>
            <li class="none-data">등록된 진단신청이 없습니다.</li>
          </ul>
        </div>

        <div class="glores-B-paginate">
          <div class="ui-pagenate"></div>
        </div>
      </div>
    </div>
    <n-modal
      v-model:show="showOrderDetailModal"
      preset="card"
      style="width: 800px; max-width: 90vw; max-height: 600px"
      title="견적 상세 정보"
      :bordered="true"
      :closable="true"
      :mask-closable="true"
      @after-leave="selectedOrderDetail = null"
    >
      <div
        v-if="selectedOrderDetail"
        class="order-detail-modal-content"
        style="overflow-y: auto; max-height: calc(600px - 150px)"
      >
        <n-descriptions
          label-placement="left"
          bordered
          :column="2"
          size="small"
          title="진단신청 정보"
        >
          <n-descriptions-item label="기관명">{{
            selectedOrderDetail.client?.name || "N/A"
          }}</n-descriptions-item>
          <n-descriptions-item label="총 금액"
            >{{
              (selectedOrderDetail.totalPrice || 0).toLocaleString()
            }}원</n-descriptions-item
          >
          <n-descriptions-item label="상태">{{
            getQuotationStatusString(selectedOrderDetail.status)
          }}</n-descriptions-item>
          <n-descriptions-item label="생성일">
            {{
              selectedOrderDetail.createdDate
                ? common.getYYYYMMDD2(
                    new Date(Number(selectedOrderDetail.createdDate))
                  )
                : "N/A"
            }}
          </n-descriptions-item>
          <n-descriptions-item label="견적서 수신자">{{
            selectedOrderDetail.receiver_email || "N/A"
          }}</n-descriptions-item>
        </n-descriptions>

        <div
          v-if="
            selectedOrderDetail.products &&
            selectedOrderDetail.products.length > 0
          "
          style="margin-top: 20px"
        >
          <h4 style="margin-bottom: 10px; font-size: 1.1em">신청 상품 목록</h4>
          <div
            v-for="(item, index) in selectedOrderDetail.products"
            :key="item.SK || `product-${index}`"
            class="product-item-card-modal"
          >
            <n-descriptions
              label-placement="top"
              bordered
              :column="3"
              size="small"
            >
              <template #header>
                상품 {{ index + 1 }}: {{ item.name }}
              </template>
              <n-descriptions-item label="단가">
                {{ (item.unit_price || 0).toLocaleString() }}원
              </n-descriptions-item>
              <n-descriptions-item label="수량">
                {{ item.quantity }}
              </n-descriptions-item>
              <n-descriptions-item label="공급가액">
                {{ (item.supply_price || 0).toLocaleString() }}원
              </n-descriptions-item>
            </n-descriptions>
          </div>
        </div>
        <div v-else style="margin-top: 20px; text-align: center; color: #888">
          진단신청에 포함된 상품이 없습니다.
        </div>

        <div v-if="selectedOrderDetail.payment_method" style="margin-top: 20px">
          <h4 style="margin-bottom: 10px; font-size: 1.1em">결제 정보</h4>
          <n-descriptions
            label-placement="left"
            bordered
            :column="1"
            size="small"
          >
            <n-descriptions-item label="결제 방법">
              {{
                selectedOrderDetail.payment_method.type === "bank_deposit"
                  ? "계좌이체"
                  : selectedOrderDetail.payment_method.type || "N/A"
              }}
            </n-descriptions-item>
            <n-descriptions-item label="입금자명">
              {{ selectedOrderDetail.payment_method.deposit_name || "N/A" }}
            </n-descriptions-item>
            <n-descriptions-item label="입금 예정일">
              {{
                selectedOrderDetail.payment_method.bank_date
                  ? common.getYYYYMMDD2(
                      new Date(selectedOrderDetail.payment_method.bank_date)
                    )
                  : "N/A"
              }}
            </n-descriptions-item>
            <n-descriptions-item label="결제 계좌">
              우리은행 : 1005-104-783814, 예금주: (주)코코랩
            </n-descriptions-item>
          </n-descriptions>
        </div>
      </div>
      <div v-else style="text-align: center; padding: 20px">
        상세 정보를 불러오는 중이거나, 선택된 진단신청이 없습니다.
      </div>
      <template #footer>
        <div style="width: 100%; text-align: center">
          <n-button @click="showOrderDetailModal = false">닫기</n-button>
        </div>
      </template>
    </n-modal>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, h, computed, watch } from "vue";
import MyPageSidebar from "@/views/member/MypageSidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import {
  NDataTable,
  NButton,
  NSpace,
  useMessage,
  NModal,
  NDescriptions,
  NDescriptionsItem,
  NCard,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useRouter } from "vue-router";
import { getQuotationStatusString } from "@/composables/useOrderForm";
import { Order } from "@/model/order";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const message = useMessage();
const router = useRouter();

watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

const pageLoading = ref(false);
const listLoading = ref(false);
const error = ref<string | null>(null);
const orders = ref<Order[]>([]);

const showOrderDetailModal = ref(false);
const selectedOrderDetail = ref<Order | null>(null);
const getCallApiCallable = getCallable("callApi");
const getMyOrders = "getMyOrders";

const columns = computed(() => [
  {
    title: "신청일",
    key: "createdDate",
    render: (row: Order) =>
      common.getYYYYMMDD2(new Date(Number(row.createdDate))),
  },
  {
    title: "총 금액",
    key: "totalPrice",
    render: (row: Order) => `${(row.totalPrice || 0).toLocaleString()}원`,
  },
  {
    title: "상태",
    key: "status",
    render: (row: Order) => getQuotationStatusString(row.status),
  },
  {
    title: "관리",
    key: "actions",
    width: 100, // 버튼 두 개를 넣기 위해 너비 조정
    render(row: Order) {
      return h(
        NButton,
        {
          size: "small",
          type: "default",
          style: "margin-right: 6px;",
          onClick: () => viewOrderDetails(row),
        },
        { default: () => "상세보기" }
      ); // NSpace로 버튼들을 감싸서 반환
    },
  },
]);

const pagination = ref({ pageSize: 10 }); // 페이지네이션 설정

async function fetchUserOrders() {
  listLoading.value = true;
  error.value = null;
  try {
    const result = await getCallApiCallable(
      makeCallApiParam(getMyOrders, {
        type: constant.orderType.BODY,
        subType: constant.orderSubType.QUOTATION,
      })
    );
    orders.value = common.getItemListFromFunctionResult(result) as Order[];
  } catch (err: any) {
    console.error("사용자 견적 목록 로딩 실패:", err);
    error.value = "견적 목록을 불러오는데 실패했습니다.";
    orders.value = [];
  } finally {
    listLoading.value = false;
  }
}

function viewOrderDetails(order: Order) {
  selectedOrderDetail.value = order;
  showOrderDetailModal.value = true;
}

function gotoOrderProject(orderSK: string) {
  router.push({
    name: USER_ROUTES.Mypage.Order.Org.Project.Name,
    params: { SK: orderSK },
  });
}

function gotoOrderProjectDetail(orderSK: string) {
  router.push({
    name: USER_ROUTES.Mypage.Order.Org.Project.Detail.Name,
    params: { SK: orderSK },
  });
}

onMounted(() => {
  fetchUserOrders();
});
</script>

<style scoped>
.product-item-card-modal {
  border: 1px solid #eee;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  background-color: #f9f9f9;
}
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.sub_scroll_wrap {
  overflow: hidden;
  height: 39px;
  border-bottom: 1px solid #ccc;
  background: #fff;
}
.sub_scroll_wrap > div {
  position: relative; /*padding: 0 30px;*/
}
.sub_scroll_wrap > div > div {
  overflow-x: scroll;
}
.sub_scroll_wrap > div > div .scroll_nav {
  display: inline-block;
  min-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  font-size: 0;
  text-align: center;
  white-space: nowrap;
}
.sub_scroll_wrap > div > div .scroll_nav li {
  display: inline-block;
}
.sub_scroll_wrap > div > div .scroll_nav li a {
  display: inline-block;
  height: 39px;
  line-height: 39px;
  padding: 0 12px;
  font-size: 13px;
  color: #bbb;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  font-weight: 600;
}
.sub_scroll_wrap > div > div .scroll_nav li.on a {
  color: #be7b42;
  font-weight: 600;
}
.sub_scroll_wrap > div i {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 39px;
}
.sub_scroll_wrap > div i.prev:before {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-right-color: #333;
}
.sub_scroll_wrap > div i.next {
  right: 0;
  left: inherit;
}
.sub_scroll_wrap > div i.next:before {
  content: "";
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-left-color: #333;
}
@media screen and (min-width: 768px) {
  .sub_scroll_wrap > div i {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .sub_scroll_wrap {
    overflow: visible;
    height: auto;
    border-bottom: none;
    background: #fff;
    box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);
  }
  .sub_scroll_wrap > div {
    position: relative;
    padding: 0;
  }
  .sub_scroll_wrap > div > div {
    overflow: hidden;
  }
  .sub_scroll_wrap > div > div .scroll_nav {
    display: table;
    margin: 0;
    width: 100%;
    padding: 0;
    white-space: normal;
    text-align: left;
    border-collapse: collapse;
  }
  .sub_scroll_wrap > div > div .scroll_nav li {
    display: table-cell;
    width: 33%;
    position: relative;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    background: #bbb;
    width: 1px;
    height: 15px;
    margin-top: -7px;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:last-child:after {
    display: none;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:before {
    position: absolute;
    visibility: hidden;
    left: 0;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 3px;
    background: #be7b42;
    content: "";
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 0.85;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 60px;
    line-height: 60px;
    padding: 0 5px;
    font-size: 16px;
    text-align: center;
    color: #bbbbbb;
    font-weight: 600;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a:hover {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on a {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on:before,
  .sub_scroll_wrap > div > div .scroll_nav li:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

.sub04_wrap * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.sub04_wrap > ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.sub04_wrap > ul li {
  width: 48%;
}
.sub04_wrap > ul li figure {
  border: 1px solid #ddd;
}
.sub04_wrap > ul li:nth-child(-n + 2) {
  margin-bottom: 30px;
}
.sub04_wrap > ul li a {
  display: block;
  border-radius: 10px;
  position: relative;
  transition: all.2s;
}
.sub04_wrap > ul li h1 {
  font-size: 14px;
  font-weight: 500;
  padding-top: 15px;
  text-align: center;
}
.sub04_wrap > ul li a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.sub04_wrap > ul li a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}
@media screen and (min-width: 768px) {
  .sub04_wrap > ul {
    justify-content: normal;
  }
  .sub04_wrap > ul li h1 {
    font-size: 16px;
  }
  .sub04_wrap > ul li {
    width: 23.5%;
    margin-right: 2%;
  }
  .sub04_wrap > ul li:nth-child(-n + 2) {
    margin-bottom: 0px;
  }
  .sub04_wrap > ul li:last-child {
    margin-right: 0;
  }
  .sub04_wrap > ul li a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}

@media all and (min-width: 768px) {
  .glores-B-list-h2 .glores-B-full-select-btn select[name="myreg_idx"] {
    width: auto;
    min-width: 250px;
  }
}
</style>
